"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propSelector = exports.impersonationToken = exports.customerSearchApiEndPointUrl = exports.configSelector = exports.backURLSelector = void 0;

var _appConstants = require("../constants/appConstants");

var customerSearchApiEndPointUrl = function customerSearchApiEndPointUrl(state) {
  var _state$pkgName, _state$config$data$wi;

  var instanceId = (_state$pkgName = state[_appConstants.pkgName]) === null || _state$pkgName === void 0 ? void 0 : _state$pkgName.instanceId;
  return state.config.data && ((_state$config$data$wi = state.config.data.widgets[_appConstants.pkgName][instanceId]) === null || _state$config$data$wi === void 0 ? void 0 : _state$config$data$wi.customerSearchApiEndPointUrl);
};

exports.customerSearchApiEndPointUrl = customerSearchApiEndPointUrl;

var impersonationToken = function impersonationToken(state) {
  var _state$pkgName2, _state$config$data$wi2;

  var instanceId = (_state$pkgName2 = state[_appConstants.pkgName]) === null || _state$pkgName2 === void 0 ? void 0 : _state$pkgName2.instanceId;
  return state.config.data && ((_state$config$data$wi2 = state.config.data.widgets[_appConstants.pkgName][instanceId]) === null || _state$config$data$wi2 === void 0 ? void 0 : _state$config$data$wi2.impersonationApiEndPointUrl);
};

exports.impersonationToken = impersonationToken;

var backURLSelector = function backURLSelector(state) {
  var _state$pkgName3, _state$config$data$wi3;

  var instanceId = (_state$pkgName3 = state[_appConstants.pkgName]) === null || _state$pkgName3 === void 0 ? void 0 : _state$pkgName3.instanceId;
  return state.config.data && ((_state$config$data$wi3 = state.config.data.widgets[_appConstants.pkgName][instanceId]) === null || _state$config$data$wi3 === void 0 ? void 0 : _state$config$data$wi3.backURL);
};

exports.backURLSelector = backURLSelector;

var configSelector = function configSelector(state) {
  var _state$config, _state$config$data;

  var myWidget = (_state$config = state.config) === null || _state$config === void 0 ? void 0 : (_state$config$data = _state$config.data) === null || _state$config$data === void 0 ? void 0 : _state$config$data.widgets[_appConstants.pkgName];

  if (myWidget) {
    var _state$pkgName4;

    var insID = (_state$pkgName4 = state[_appConstants.pkgName]) === null || _state$pkgName4 === void 0 ? void 0 : _state$pkgName4.instanceId;
    return myWidget[insID];
  }

  return null;
};

exports.configSelector = configSelector;

var propSelector = function propSelector(state, prop) {
  var WidgetConf = configSelector(state);

  if (WidgetConf) {
    return WidgetConf[prop];
  }

  return null;
};

exports.propSelector = propSelector;